import styled from 'styled-components'

export const OrdersContainer = styled.section`
  display: flex;
  flex-direction: column;
  background: #f8f8f8;
  padding: 0;
  border-radius: 0.5rem;
  width: 100%;

  /* Media queries para responsividade mobile */
  @media (max-width: 768px) {
    padding: 0;
  }

  @media (max-width: 480px) {
    padding: 0;
  }

  .order_wrapper {
    background: #fff;
    height: 100%;
    border-radius: 0.5rem;
    padding: 16px;
    margin: 0;

    /* Responsividade mobile para wrapper */
    @media (max-width: 768px) {
      padding: 12px;
    }

    @media (max-width: 480px) {
      padding: 8px;
    }

    .order_title {
      display: flex;
      align-items: center;
      color: #21976e;
      font-size: 2rem;
      font-family: 'Poppins', sans-serif !important;

      /* Responsividade mobile para título */
      @media (max-width: 768px) {
        font-size: 1.5rem;
      }

      @media (max-width: 480px) {
        font-size: 1.25rem;
      }
    }

    .order_subtitle {
      display: flex;
      align-items: center;
      color: #21976e;
      font-size: 0.8rem;
      font-family: 'Poppins', sans-serif !important;
      svg {
        font-size: 4rem;
        margin-right: 16px;
      }

      /* Responsividade mobile para subtítulo */
      @media (max-width: 768px) {
        font-size: 0.75rem;

        svg {
          font-size: 3rem;
          margin-right: 12px;
        }
      }

      @media (max-width: 480px) {
        font-size: 0.7rem;

        svg {
          font-size: 2.5rem;
          margin-right: 8px;
        }
      }
    }

    .order_filter {
      display: flex;
      justify-content: space-between;
      padding: 1rem;
      align-items: center;
      background: #ffffff;
      width: 100%;
      height: auto;
      p {
        margin-left: 24px;
      }

      /* Responsividade mobile para filtro */
      @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        gap: 1rem;
        padding: 0.75rem;

        p {
          margin-left: 0;
          text-align: center;
          font-size: 0.9rem;
          color: #666;
        }
      }

      @media (max-width: 480px) {
        padding: 0.5rem;
        gap: 0.75rem;

        p {
          font-size: 0.8rem;
        }
      }
    }

    .order_list {
      margin-top: 16px;
      width: 100%;

      .card_order_header {
        width: 100%;
        display: flex;
        border: 1px solid #ccc;
        height: 50px;
        align-items: center;
        border-radius: 6px;
        color: black;
        background-color: #e9e9e9;
        padding: 0 16px;
        margin-bottom: 16px;
        .card_order_id {
          width: 45%;
        }
        .card_order_date {
          width: 45%;
        }
        .card_order_amount {
          width: 45%;
        }

        /* Ocultar header em mobile */
        @media (max-width: 768px) {
          display: none;
        }
      }

      .card_order {
        .card_order_id {
          width: 40%;
        }
        .card_order_date {
          width: 40%;
        }

        .card_order_amount {
          width: 20%;
        }
        width: 100%;
        display: flex;
        padding: 0 16px;
        height: 60px;
        border: 1px solid #ccc;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
        border-radius: 6px;

        /* Layout mobile para cards */
        @media (max-width: 768px) {
          flex-direction: column;
          align-items: stretch;
          height: auto;
          padding: 1rem;
          gap: 0.75rem;

          .card_order_id,
          .card_order_date,
          .card_order_amount,
          .card_order_status {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 0.9rem;

            &::before {
              font-weight: 600;
              color: #666;
              margin-right: 0.5rem;
            }
          }

          .card_order_id::before {
            content: 'Nº do pedido:';
          }

          .card_order_date::before {
            content: 'Data da compra:';
          }

          .card_order_amount::before {
            content: 'Valor do pedido:';
          }

          .card_order_status {
            margin-top: 0.5rem;
            justify-content: center;

            button {
              width: 100%;
              min-height: 44px;
              padding: 0.75rem 1rem;
              font-size: 0.9rem;
              border-radius: 6px;
              transition: all 0.2s ease;

              &:hover {
                background-color: #f0f0f0;
              }

              &:active {
                transform: scale(0.98);
              }
            }
          }
        }

        @media (max-width: 480px) {
          padding: 0.75rem;
          gap: 0.5rem;

          .card_order_id,
          .card_order_date,
          .card_order_amount {
            font-size: 0.85rem;

            &::before {
              font-size: 0.8rem;
            }
          }

          .card_order_status button {
            font-size: 0.85rem;
            padding: 0.625rem 0.75rem;
          }
        }
      }
    }
  }
`
